import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchAllClaimsStarted = () => {
  return {
    type: actionTypes.FETCH_ALL_CLAIMS_STARTED,
  };
};
export const fetchAllClaimsSuccess = (claims, total) => {
  return {
    type: actionTypes.FETCH_ALL_CLAIMS_SUCCESS,
    claims: claims,
    total: total,
  };
};
export const fetchAllClaimsFailed = (errorMessage) => {
  return {
    type: actionTypes.FETCH_ALL_CLAIMS_FAILED,
    errorMessage: errorMessage,
  };
};
export const resetFetchAllClaims = () => {
  return {
    type: actionTypes.RESET_FETCH_ALL_CLAIMS,
  };
};
export const fetchAllClaims = (
  patientId: number,
  limit: number,
  page: number
) => {
  console.log("limit", limit);
  console.log("offset", page);
  return (dispatch) => {
    if (page === 0) {
      dispatch(fetchAllClaimsStarted());
    }
    // const url = `balance-billing/claims/by-patient-id`;
    const formData = {
      patientId: patientId, // Patient Id is numeric, not the encrypted id
      limit: limit, // How many results to load
      page: page,
    };
    axios
      .post(serverconfigs.fetchAllClaimsUrl, formData)
      .then((response) => {
        console.log(response.data);
        dispatch(
          fetchAllClaimsSuccess(
            response.data.result.claims,
            response.data.result.total
          )
        );
      })
      .catch((error) => {
        console.log(error.message);
        if (error.statusCode === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            dispatch(fetchAllClaimsFailed(error.response.data.message));
          } else {
            dispatch(fetchAllClaimsFailed(error.message));
          }
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
          dispatch(fetchAllClaimsFailed(error.message));
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
          dispatch(fetchAllClaimsFailed(error.message));
        } else dispatch(fetchAllClaimsFailed(error.message));
      });
    // const result = {
    //   claims: [
    //     {
    //       id: 1335485,
    //       claimNumber: "201910170100",
    //       dateOfService: "2019-08-26T04:00:00.000Z",
    //       patientId: 895723,
    //       billedAmount: 1826.33,
    //       providerName: "POUDRE VALLEY HEALTH CARE INC",
    //       balanceBillStatus: {
    //         id: 27,
    //         name:
    //           "AMPS Sends 2nd Fair Credit Billing Act (FCBA) Violation Letter to Provider or Extended Billing Office. Notifies Member",
    //         tip:
    //           "Statements from your provider that your credit will be impacted are typically used as a scare tactic to get you to pay the invalid balance. Do not pay these and notify AMPS immediately.",
    //       },
    //     },
    //     {
    //       id: 1343338,
    //       claimNumber: "201910290337",
    //       dateOfService: "2019-08-19T04:00:00.000Z",
    //       patientId: 895723,
    //       billedAmount: 2142.48,
    //       providerName: "POUDRE VALLEY HEALTH CARE INC",
    //     },
    //   ],
    //   meta: {
    //     limit: 2,
    //     offset: 0,
    //     totalCount: 17,
    //   },
    // };
    // dispatch(fetchAllClaimsSuccess(result.claims));
  };
};
